export const urls = {
  VARATI_RABATNEGRUPE: 'RabatneGrupe/vrati_rabatne_grupe',
  DELETE_RABATNEGRUPE: 'RabatneGrupe/brisanje_rabatne_grupe',
  INSERT_RABATNEGRUPE: 'RabatneGrupe/unos_rabatne_grupe',
  UPDATE_RABATNEGRUPE: 'RabatneGrupe/izmena_rabatne_grupe',
};
